/**
 * @generated SignedSource<<89714500d78c652614735f3913247234>>
 * @relayHash fc38e048c7a98c33e23500c1668205bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4faa8428f94d278152de728341c0d4bba4c0457f1776bd555a4abb9d21012c55

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraMultiValueFieldOperations = "ADD" | "REMOVE" | "SET" | "%future added value";
export type JiraUpdateComponentsFieldInput = {
  id: string;
  operations: ReadonlyArray<JiraComponentFieldOperationInput>;
};
export type JiraComponentFieldOperationInput = {
  ids: ReadonlyArray<string>;
  operation: JiraMultiValueFieldOperations;
};
export type ui_issueViewComponentsField_Mutation$variables = {
  input: JiraUpdateComponentsFieldInput;
};
export type ui_issueViewComponentsField_Mutation$data = {
  readonly jira: {
    readonly updateComponentsField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly selectedComponentsConnection: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly ari: string | null | undefined;
              readonly componentId: string;
              readonly description: string | null | undefined;
              readonly id: string;
              readonly metadata: AGG$JSON | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_issueViewComponentsField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateComponentsField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly selectedComponentsConnection: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly ari: string | null | undefined;
              readonly componentId: string;
              readonly description: string | null | undefined;
              readonly id: string;
              readonly metadata: AGG$JSON | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_issueViewComponentsField_Mutation = {
  rawResponse: ui_issueViewComponentsField_Mutation$rawResponse;
  response: ui_issueViewComponentsField_Mutation$data;
  variables: ui_issueViewComponentsField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "concreteType": "JiraComponentConnection",
  "kind": "LinkedField",
  "name": "selectedComponentsConnection",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraComponentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraComponent",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "ari"
            },
            {
              "kind": "ScalarField",
              "name": "metadata"
            },
            {
              "kind": "ScalarField",
              "name": "componentId"
            },
            {
              "kind": "ScalarField",
              "name": "description"
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_issueViewComponentsField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraComponentsFieldPayload",
            "kind": "LinkedField",
            "name": "updateComponentsField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraComponentsField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_issueViewComponentsField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraComponentsFieldPayload",
            "kind": "LinkedField",
            "name": "updateComponentsField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraComponentsField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4faa8428f94d278152de728341c0d4bba4c0457f1776bd555a4abb9d21012c55",
    "metadata": {},
    "name": "ui_issueViewComponentsField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "776492051e9d3dbfb68270ec37c40018";

export default node;
